<template>
  <page-list
    :list="list"
    :columns="columns"
    :group-actions="groupActions"
    :singleActions="singleActions" />
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ListMixin from '@/mixins/list'
import WindowsMixin from '@/mixins/windows'
import { getTimeTableColumn, getStatusTableColumn } from '@/utils/common/tableColumn'

export default {
  name: 'HistoricalRateList',
  mixins: [WindowsMixin, ListMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      loading: false,
      list: this.$list.createList(this, {
        id: 'discountInfoList',
        resource: 'rates',
        apiVersion: 'v1',
        getParams: {
          filter: [
            `cloudaccount_id.equals(${this.data.cloudaccount_id})`, // ${this.data.cloudaccount_id}
            `resource_type.equals("${this.data.resource_type}")`,
            `model.equals("${this.data.model || ''}")`,
          ],
        },
      }),
      columns: [
        {
          field: 'price',
          title: this.$t('scope.text_538'),
          formatter: ({ row, cellValue }) => {
            if (row.price_type === 'percent') {
              return cellValue * 100 + '%'
            } else {
              return cellValue + (row.unit || '')
            }
          },
        },
        getTimeTableColumn({ field: 'enable_time', title: this.$t('scope.text_511') }),
        getStatusTableColumn({ statusModule: 'rate' }),
      ],
      groupActions: [
        {
          label: this.$t('scope.text_672'),
          action: () => {
            this.createDialog('UpdateRateDialog', {
              title: this.$t('scope.text_673'),
              onManager: this.onManager,
              refresh: this.refresh,
              cloudaccountId: this.data.cloudaccount_id,
              domain_id: this.data.domain_id,
              brand: this.data.brand,
              resourceType: this.data.resource_type,
              unit: this.data.misc.unit,
              price_type: this.data.price_type,
              type: 'create',
            })
          },
          meta: () => ({ buttonType: 'primary' }),
        },
      ],
      singleActions: [
        {
          label: this.$t('scope.text_634'),
          action: (obj) => {
            this.createDialog('UpdateRateDialog', {
              title: this.$t('scope.text_674'),
              onManager: this.onManager,
              data: [obj],
              cloudaccountId: this.data.cloudaccount_id,
              domain_id: this.data.domain_id,
              brand: this.data.brand,
              resourceType: this.data.resource_type,
              price_type: this.data.price_type,
              unit: this.data.misc.unit,
              type: 'edit',
              refresh: this.refresh,
            })
          },
          meta: (obj) => {
            return {
              validate: obj.status === 'unavailable',
            }
          },
        },
        {
          label: this.$t('scope.text_675'),
          action: (obj) => {
            this.createDialog('DeleteResDialog', {
              vm: this,
              data: [obj],
              columns: this.columns,
              title: this.$t('scope.text_675'),
              onManager: this.onManager,
            })
          },
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['scope']),
    ...mapState('app', {
      customer: state => state.customer,
    }),
  },
  created () {
    this.list.fetchData()
  },
}
</script>
